/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListUnhandledJobsJobDtoFromJSON, ListUnhandledJobsJobDtoToJSON, } from './ListUnhandledJobsJobDto.js';
/**
 * Check if a given object implements the ListUnhandledJobsResult interface.
 */
export function instanceOfListUnhandledJobsResult(value) {
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    return true;
}
export function ListUnhandledJobsResultFromJSON(json) {
    return ListUnhandledJobsResultFromJSONTyped(json, false);
}
export function ListUnhandledJobsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobs': (json['jobs'].map(ListUnhandledJobsJobDtoFromJSON)),
    };
}
export function ListUnhandledJobsResultToJSON(json) {
    return ListUnhandledJobsResultToJSONTyped(json, false);
}
export function ListUnhandledJobsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobs': (value['jobs'].map(ListUnhandledJobsJobDtoToJSON)),
    };
}
